export default __webpack_public_path__ + "static/media/ic-loginlogo.9dfdf46d.png";